export default {
  data() {
    return {
      rowSpanArr: [], // 行合并数数组，每项为行合并数，0-不显示
      spanColumnIndexArr: [] // 合并列索引数组
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 获取表格行合并数组
    getTableRowSpanArr(recordArr, key) {
      this.rowSpanArr = []
      let rowIndex = 0
      for (let i = 0; i < recordArr.length; i++) {
        if (i === 0) {
          this.rowSpanArr.push(1)
        } else {
          // 判断当前元素key与上一个元素key是否相同
          if (recordArr[i][key] === recordArr[i - 1][key]) {
            this.rowSpanArr[rowIndex] += 1 // 当前行合并到上一行，累加跨行数
            this.rowSpanArr.push(0) // 当前行行数为0，不显示
          } else {
            this.rowSpanArr.push(1) // 当前行行数为1
            rowIndex = i
          }
        }
        // console.log(this.rowSpanArr)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.spanColumnIndexArr.indexOf(columnIndex) >= 0) { // 判断当前列是否属于合并行的列
        const rowSpanCount = this.rowSpanArr[rowIndex] // 返回当前行的合并行数
        const colCount = rowSpanCount > 0 ? 1 : 0 // 当前行行数为0，则列数设置为0，不显示
        // console.log(`rowspan:${rowSpanCount} colspan:${colCount}`)
        return { // {0,0} 表示行为0，列为0，该行不显示， {2,1}表示行的合并数为2，列为1
          rowspan: rowSpanCount,
          colspan: colCount
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table-span-mixin.js